export var StorageChangeOrigin;
(function (StorageChangeOrigin) {
    StorageChangeOrigin["All"] = "all";
    StorageChangeOrigin["External"] = "external";
    StorageChangeOrigin["Internal"] = "internal";
})(StorageChangeOrigin || (StorageChangeOrigin = {}));
export var StorageChangeKeyMatch;
(function (StorageChangeKeyMatch) {
    StorageChangeKeyMatch["Start"] = "start";
    StorageChangeKeyMatch["Full"] = "full";
})(StorageChangeKeyMatch || (StorageChangeKeyMatch = {}));
//# sourceMappingURL=storage-change.js.map